import { Controller } from "@hotwired/stimulus";

// Two usage shapes:
//   1. data-controller="modal" directly on a <dialog> — auto-opens on
//      connect (original usage: a validation-error dialog the server only
//      renders into the DOM when there's actually an error to show, see
//      teams/_panel_body.html.erb).
//   2. data-controller="modal" on a wrapper <div> around a trigger button
//      and a <dialog data-modal-target="dialog">, opened on demand via
//      data-action="click->modal#open" (see the técnico/presidente/supervisor
//      "cartões" modal in games/_live_game_card.html.erb) — doesn't auto-open,
//      since the dialog lives in the DOM from page load and should stay
//      closed until the referee actually clicks the trigger.
export default class extends Controller {
  static targets = ["dialog"];

  connect() {
    if (!this.hasDialogTarget) this.element.showModal();
  }

  open() {
    this.dialogTarget.showModal();
  }

  close() {
    (this.hasDialogTarget ? this.dialogTarget : this.element).close();
  }
}
